var template = require('./main.html');

export {
  template,
};
